import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { FormEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { AlertCircle, Loader2 } from "lucide-react";
import { Button } from "./core/Button";
import { useAuth } from "../graphql/hooks/useAuth";
import { useSetPassword } from '../graphql/hooks/useUserDashboard';
import enttroLogo from "../assets/logo.png";
import { InputPassword } from './core/InputPasswort';

export function FirstLogin() {
  const { mutateAsync: setPassword } = useSetPassword();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const userId = searchParams.get("user_id");

  const [password, setPasswordValue] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");

    if (!token || !userId) {
      setError("Ungültiger Link");
      return;
    }

    if (!password || !confirmPassword) {
      setError("Bitte alle Felder ausfüllen");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwörter stimmen nicht überein");
      return;
    }

    try {
      setIsLoading(true);

      await setPassword({
        user_id: userId,
        token,
        password,
      });
    navigate("/", { replace: true });

    } catch (err) {
      setError(
        "Passwort konnte nicht gesetzt werden"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid =
    password.trim() !== "" &&
    confirmPassword.trim() !== "";

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a2540] via-[#0d3a5f] to-[#0a2540] flex items-center justify-center p-4">

      <div className="w-full max-w-[520px] bg-white rounded-[16px] shadow-2xl p-8">

        <div className="text-center mb-8">
          <img src={enttroLogo} className="h-14 mx-auto mb-4" />
          <h2 className="text-[24px] font-medium">
            Neues Passwort setzen
          </h2>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-[10px] flex gap-3">
            <AlertCircle className="size-5 text-red-600" />
            <p className="text-red-600 text-[14px]">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">

          {/* Password */}
          <InputPassword
            label="Neues Passwort"
            value={password}
            setValue={setPasswordValue}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            isLoading={isLoading}
          />

          {/* Confirm */}
          <InputPassword
            label="Passwort bestätigen"
            value={confirmPassword}
            setValue={setConfirmPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            isLoading={isLoading}
          />

          <Button
            type="submit"
            fullWidth
            disabled={!isFormValid || isLoading}
            icon={
              isLoading ? (
                <Loader2 className="size-5 animate-spin" />
              ) : undefined
            }
          >
            Passwort setzen
          </Button>
        </form>
      </div>
    </div>
  );
}